var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product_image"},[_c('AppImage',{staticClass:"mx-auto w-full lg:w-auto",attrs:{"loading":"lazy","src":_vm.item.product_image,"alt":_vm.item.product_image_alt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }